import { connect } from 'react-redux';

import PractitionerRegister from './component';

export default connect(null, (dispatch) => ({
  locationPractitionerLogin: () => dispatch({
    type: 'PRACTITIONER_LOGIN',
  }),
}))(PractitionerRegister);
